export const isDevelopment =
  window.location.hostname === 'localhost' || window.location.hostname === 'local.mylaborelec.com' || window.location.protocol === 'http:';

export const oktaConfig = {
  issuer: import.meta.env.VITE_OKTA_ISSUER || 'https://renewables.okta.com/oauth2/default',
  clientId: import.meta.env.VITE_OKTA_CLIENT_ID || 'your-client-id',
  redirectUri: window.location.origin + '/login/callback',
  postLogoutRedirectUri: window.location.origin,
  scopes: ['openid', 'profile', 'email', 'soiling-mitigation'],
  pkce: true,
  responseType: 'code' as const,
  tokenManager: {
    autoRenew: true,
    secure: true,
  },
};
